import { render, staticRenderFns } from "./expandable-information.vue?vue&type=template&id=5101a808&"
import script from "./expandable-information.vue?vue&type=script&lang=js&"
export * from "./expandable-information.vue?vue&type=script&lang=js&"
import style0 from "./expandable-information.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports